import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=32fae01c&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=32fae01c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fae01c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32fae01c')) {
      api.createRecord('32fae01c', component.options)
    } else {
      api.reload('32fae01c', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=32fae01c&scoped=true&", function () {
      api.rerender('32fae01c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2J0FB2jWlGFqV/JS/comp/DateRangeExt.vue"
export default component.exports